import React, { useState } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import noop from 'lodash/noop'
import OperationalTable, { useOperationalTable } from '../../../organisms/OperationalTable'
import { useAppContext } from '../../../../redux/slices/appContext'
import SydButton from '../../../commonDesign/Button'
import PostToVaultModal from '../Reports/PostToVault/PostToVaultModal'
import SnackAlert from '../../../molecules/SnackAlert/SnackAlert'
import InfographicNavigation from './components/InfographicNavigation'
import { CreateInfographicReportForm } from './components/CreateInfographicReportForm'
import { useInfographicRunColumnConfig } from './hooks/useInfographicRunColumnConfig'
import { reportStatusClasses } from './classes'
import { useListInfographicReportRuns } from './hooks/useListInfographicReportRuns'

const useStyles = makeStyles(() => ({
  container: {
    padding: '1rem',
    display: 'flex',
    flex: '1',
    flexDirection: 'column'
  },
  statusContainer: {
    width: '6rem'
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '1rem 0 0',
    gap: '1rem',
    '& a': {
      opacity: 0.25,
      '&.active': {
        opacity: 1
      }
    }
  },
  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  ...reportStatusClasses
}))

const InfographicReportsView = () => {
  const { isSummitUser } = useAppContext()
  const [postToVaultData, setPostToVaultData] = useState({})
  const [alert, setAlert] = useState({})

  const classes = useStyles()
  const columnConfig = useInfographicRunColumnConfig({
    classes,
    isSummitUser,
    onSetPostToClientVault: ({ clientId, title, reportRunId }) => setPostToVaultData({ clientId, title, reportRunId, reportType: 'infographic' })
  })

  const {
    pageIndex,
    pageSize,
    sort,
    onPagingChange,
    onSortingChange
  } = useOperationalTable(columnConfig)

  const { data, isLoading, isFetching, refetch } = useListInfographicReportRuns({
    limit: pageSize,
    offset: pageIndex * pageSize,
    sort
  })
  const onPostToVaultSubmit = async (alert) => {
    if (alert) {
      setAlert(alert)
    }
    setPostToVaultData({})
    await refetch()
  }

  return (
    <div className={classes.container}>
      <InfographicNavigation />
      <Box mt={2}>
        <CreateInfographicReportForm
          onSubmit={() => refetch()}
        />
      </Box>

      <div className='flex justify-end mb-2'>
        <SydButton
          onClick={isFetching ? noop : refetch}
          disabled={isFetching}
          size='sm'
          variant='primary'
          icon={isFetching ? 'Spinner' : null}
        >
          {isFetching ? 'Loading...' : 'Refresh'}
        </SydButton>
      </div>

      <OperationalTable.Wrapper>
        <OperationalTable
          showTotalItemsLabel={false}
          autoSticky
          mode='server'
          columns={columnConfig.columns}
          data={data || []}
          defaultPageSize={columnConfig.defaultPageSize}
          defaultSort={columnConfig.defaultSort}
          itemName='Reports'
          loading={isLoading || isFetching}
          total={data?.length || 0}
          onSortingChange={onSortingChange}
          onPagingChange={onPagingChange}
          pageSizeOptions={[10, 20, 50, 100]}
        />
      </OperationalTable.Wrapper>

      <PostToVaultModal
        data={postToVaultData}
        onSubmit={onPostToVaultSubmit}
        onClose={() => setPostToVaultData({})}
      />

      <SnackAlert alert={alert} />
    </div>
  )
}

export default InfographicReportsView
